<script setup lang="ts">
import {
  PhArrowLeft as ArrowLeftIcon,
  PhFileMagnifyingGlass as FileMagnifyingGlassIcon,
} from '@phosphor-icons/vue'
</script>

<template>
  <section class="not-found">
    <FileMagnifyingGlassIcon :size="54" weight="duotone" aria-hidden="true" />
    <h1>没有找到这个页面</h1>
    <p>链接可能已经失效，或对应内容还没有发布。</p>
    <RouterLink class="button button--primary" to="/">
      <ArrowLeftIcon :size="18" aria-hidden="true" />
      返回首页
    </RouterLink>
  </section>
</template>
